var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1868B7",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M31 24L31 55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M30.5 5C18.2444 5 7.93195 13.4765 4.90211 24.9892C4.38846 26.941 7.03246 27.9186 8.59089 26.6362C9.92985 25.5344 11.4412 24.7027 12.9527 24.7027C15.4966 24.7027 17.7639 27.0583 19.2477 29.0928C20.1497 30.3297 22.1582 30.4616 23.173 29.3154C25.0153 27.2344 27.779 24.7027 30.3209 24.7027C32.8788 24.7027 35.6611 27.2662 37.5034 29.3544C38.5082 30.4934 40.4929 30.3776 41.399 29.1587C42.9223 27.1095 45.2654 24.7027 47.8682 24.7027C49.466 24.7027 51.0721 25.6096 52.4821 26.784C54.023 28.0674 56.6377 27.0897 56.139 25.1473C53.1623 13.5542 42.8116 5 30.5 5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M52.2307 40.8759C52.2307 44.5339 49.2653 47.4993 45.6073 47.4993C41.9493 47.4993 38.9839 44.5339 38.9839 40.8759C38.9839 37.2179 41.9493 34.2525 45.6073 34.2525C49.2653 34.2525 52.2307 37.2179 52.2307 40.8759Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M37 54.9616C37 50.1822 40.8745 46.3077 45.6538 46.3077C50.4332 46.3077 54.3077 50.1822 54.3077 54.9616V55.5385C54.3077 56.5581 53.4811 57.3847 52.4615 57.3847H38.8462C37.8266 57.3847 37 56.5581 37 55.5385V54.9616Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M23.2307 40.8759C23.2307 44.5339 20.2653 47.4993 16.6073 47.4993C12.9493 47.4993 9.98387 44.5339 9.98387 40.8759C9.98387 37.2179 12.9493 34.2525 16.6073 34.2525C20.2653 34.2525 23.2307 37.2179 23.2307 40.8759Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M8 54.9616C8 50.1822 11.8745 46.3077 16.6538 46.3077C21.4332 46.3077 25.3077 50.1822 25.3077 54.9616V55.5385C25.3077 56.5581 24.4811 57.3847 23.4615 57.3847H9.84615C8.82655 57.3847 8 56.5581 8 55.5385V54.9616Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon (1).cd29972d8be84b05f85e3a5ccc2beab9.svg";
export { ForwardRef as ReactComponent };